import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            redirect: '/dashboard',
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/about/About.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/dashboard/:loggedin?',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "dashboard" */ './views/dashboard/Dashboard.vue'),
            meta: {
                requiresAuth: false,
            },

        },
        {
            path: '/edit/unsynced/:unsyncedId?',
            name: 'editUnsynced',
            component: () => import(/* webpackChunkName: "edit" */ './views/edit/Edit.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/edit/:id?',
            name: 'edit',
            component: () => import(/* webpackChunkName: "edit" */ './views/edit/Edit.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/edit/:directId?',
            name: 'edit',
            component: () => import(/* webpackChunkName: "edit" */ './views/edit/Edit.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/clone/:cloneId?',
            name: 'clone',
            component: () => import(/* webpackChunkName: "edit" */ './views/edit/Edit.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/quickedit/:id?',
            name: 'quickEdit',
            component: () => import(/* webpackChunkName: "quickEdit" */ './views/quickedit/QuickEdit.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/table',
            name: 'table',
            component: () => import(/* webpackChunkName: "table" */ './views/table/Table.vue'),
            props: (to) => {
                return { myFilter: to.query.myFilter };
            },
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/settingsReport/:dataSetId?/:empty?',
            name: 'settingsReport',
            component: () => import(/* webpackChunkName: "table" */ './views/settingsreport/SettingsReportView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/settingsReport/:unsyncedEventId?',
            name: 'settingsReportUnsynced',
            component: () => import(/* webpackChunkName: "table" */ './views/settingsreport/SettingsReportView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/login/:idToken?',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './views/login/Login.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/refresh/:refreshToken?',
            name: 'refresh',
            component: () => import(/* webpackChunkName: "login" */ './views/login/Login.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/logout/:logoutParams?',
            name: 'logout',
            component: () => import(/* webpackChunkName: "login" */ './views/login/Login.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/open/:id?',
            name: 'open',
            component: () => import(/* webpackChunkName: "preview" */ './views/directOpen/DirectOpen.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/filterNew',
            name: 'filterNew',
            component: () => import(/* webpackChunkName: "filterNew" */ './views/filterNew/Filter.vue'),
            props: (to) => {
                return { myFilter: to.query.myFilter };
            },
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/preview/:id?',
            name: 'preview',
            component: () => import(/* webpackChunkName: "preview" */ './views/preview/Preview.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/quickeditWizard',
            name: 'quickeditWizard',
            component: () => import(/* webpackChunkName: "preview" */ './views/quickeditWizard/QuickeditWizard.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/myMillWizard',
            name: 'myMillWizard',
            component: () => import(/* webpackChunkName: "MyMillWizard" */ './views/myMillWizard/MyMillWizard.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/myMillWizard/unsynced/:unsyncedId?',
            name: 'myMillWizardUnsynced',
            component: () => import(/* webpackChunkName: "MyMillWizard" */ './views/myMillWizard/MyMillWizard.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/noaccess',
            name: 'noaccess',
            component: () => import(/* webpackChunkName: "noaccess" */ './views/noaccess/NoAccess.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            // catch all routes, needs to be the last item!
            path: '*',
            redirect: '/home',
        },
    ],
});
